import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import PageFrame from '../components/pageFrame';

// import Header from '../components/header'
import './index.css'
import pageFrame from '../components/pageFrame';

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title='Shane Cummerford Dot Com'
      meta={[
        { name: 'description', content: '' },
        { name: 'keywords', content: '' },
      ]}
    />
    {/*<Header siteTitle={data.site.siteMetadata.title} />*/}
    <PageFrame>
      {children()}
    </PageFrame>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js